const Vertical = () => {
  return null;
};

export default Vertical;
